import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const PrivateRoute = ({ element }) => {
    const { isAuth, StatusDocument, typePerson } = useContext(AuthContext);

    const userDetail = localStorage.getItem('userDetails');
    const parsedUser = JSON.parse(userDetail);



    // Si está en onboarding, redirige automáticamente a Splash
    if (isAuth && StatusDocument != 'APPROVED' && parsedUser?.type_person == 2) {
        return <Navigate to="/splash" />;
    }

    // Si está autenticado y no en onboarding, permite el acceso
    return isAuth ? element : <Navigate to="/login" />;
};

export default PrivateRoute;
